module.exports = __webpack_public_path__ + "img/9791185751078.c67ad639.jpg";